import { Component, HostListener, Input } from '@angular/core'
import { Router, RouterLink, RouterLinkActive } from '@angular/router'
import { AuthService } from '../services/auth.service'
import { ThemeService } from '../services/theme.service'
import { CartService } from '../services/cart.service'

@Component({
  selector: 'app-navbar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent {
  @Input() isStatic = false
  @Input() isCompact = false
  isProfileMenuOpen = false

  constructor(
    private authService: AuthService,
    private router: Router,
    public themeService: ThemeService,
    public cartService: CartService
  ) { }

  get isLoggedIn() {
    return this.authService.isLoggedIn
  }

  get currentUser() {
    return this.authService.currentUser()
  }

  get isAdmin() {
    return this.authService.isAdmin
  }

  get isSuperAdmin() {
    return this.authService.isSuperAdmin
  }

  get isSeller() {
    return this.authService.isSeller
  }

  get adminPortalRoute() {
    return this.isSuperAdmin() ? '/super-admin/overview' : '/admin'
  }

  get isManagementUser() {
    const role = this.authService.currentUser()?.role
    return role === 'admin' || role === 'super-admin' || role === 'seller'
  }

  get showAdminNavTag() {
    const url = this.router.url || ''
    return this.isManagementUser && (url.startsWith('/admin') || url.startsWith('/super-admin'))
  }

  get logoutLabel() {
    if (this.isManagementUser) return 'Admin Logout'
    return 'User Logout'
  }

  get brandRoute() {
    return '/'
  }
  closeMenu() {
  }

  toggleProfileMenu(event?: MouseEvent) {
    event?.stopPropagation()
    this.isProfileMenuOpen = !this.isProfileMenuOpen
  }

  closeProfileMenu() {
    this.isProfileMenuOpen = false
  }

  onProfileMenuClick(event: MouseEvent) {
    event.stopPropagation()
  }

  onLogout() {
    this.closeProfileMenu()
    this.closeMenu()
    this.authService.logout()
  }

  onProfileAction() {
    this.closeProfileMenu()
    this.closeMenu()
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.closeProfileMenu()
  }
}
